import {
  commonsOtherDocs2,
  concessionLetter,
  otherDocs,
  others,
} from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

export const TempoContribuicaoDocs = () => {
  const rules = {
    anexoCarta: dynamicRule(),
    anexoDecisao: dynamicRule(),

    anexoSB40Etc: dynamicRule(),

    anexoResumoTempo: dynamicRule(),
    anexoCTPS: dynamicRule('required'),
    anexoCertReservista: dynamicRule(),
  };

  const docs = [
    ...concessionLetter,
    ...otherDocs,
    ...commonsOtherDocs2,
    ...others,
  ];

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
